import React, { Component } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Home as HomeIcon, Search, Bookmark, User, Menu } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import { PhoneFrame } from './PhoneFrame';
const TABS = [{
  to: '/',
  label: 'Home',
  icon: HomeIcon,
  match: (p: string) => p === '/'
}, {
  to: '/shop',
  label: 'Shop',
  icon: Search,
  match: (p: string) => p.startsWith('/shop')
}, {
  to: '#',
  label: 'Saved',
  icon: Bookmark,
  match: () => false
}, {
  to: '#',
  label: 'Profile',
  icon: User,
  match: () => false
}];
export function Layout() {
  const location = useLocation();
  const {
    selectedCountry
  } = useAppContext();
  return <PhoneFrame data-id="element-12">
      {/* Full-height column inside the phone screen. Only <main> scrolls. */}
      <div className="flex h-full w-full flex-col bg-zinc-950" data-id="element-13">
        {/* Status bar spacer (clears the dynamic island) */}
        <div className="h-11 shrink-0" data-id="element-14" />

        {/* Top Bar */}
        <header className="shrink-0 z-50 bg-zinc-950/90 backdrop-blur-md border-b border-zinc-900 px-4 h-14 flex items-center justify-between" data-id="element-15">
          <div className="flex items-center gap-3" data-id="element-16">
            <Menu className="w-5 h-5 text-zinc-100" data-id="element-17" />
            <Link to="/" className="font-display text-lg tracking-tighter text-white flex items-center gap-1.5" data-id="element-18">
              WORLD CUP 26
              <div className="w-1.5 h-1.5 rounded-full" style={{
              backgroundColor: selectedCountry.color
            }} data-id="element-19" />
            </Link>
          </div>
          <div className="flex items-center gap-3.5" data-id="element-20">
            <Search className="w-5 h-5 text-zinc-100" data-id="element-21" />
            <div className="w-6 h-6 rounded-full bg-zinc-800 flex items-center justify-center text-[11px] border border-zinc-700" data-id="element-22">
              {selectedCountry.code}
            </div>
          </div>
        </header>

        {/* Scrollable content */}
        <main className="relative flex-1 overflow-y-auto no-scrollbar" data-id="element-23">
          <Outlet data-id="element-24" />
        </main>

        {/* Bottom Tab Nav — anchored to the phone screen, not the viewport */}
        <nav className="shrink-0 bg-zinc-950/95 backdrop-blur-md z-50" data-id="element-25">
          <div className="flex items-center justify-center gap-1.5 px-4 pt-3" data-id="element-26">
            {TABS.map(tab => <NavItem key={tab.label} to={tab.to} label={tab.label} Icon={tab.icon} active={tab.match(location.pathname)} data-id="element-27" />)}
          </div>
          {/* iOS home indicator */}
          <div className="flex justify-center pb-2 pt-2.5" data-id="element-28">
            <div className="h-1 w-32 rounded-full bg-zinc-100/80" data-id="element-29" />
          </div>
        </nav>
      </div>
    </PhoneFrame>;
}
function NavItem({
  to,
  label,
  Icon,
  active
}: {
  to: string;
  label: string;
  Icon: ComponentType<{
    className?: string;
    strokeWidth?: number;
  }>;
  active: boolean;
}) {
  return <Link to={to} aria-current={active ? 'page' : undefined} aria-label={label} className="relative" data-id="element-30">
      <motion.div layout transition={{
      type: 'spring',
      stiffness: 480,
      damping: 34
    }} className={`flex h-11 items-center gap-2 rounded-full px-4 ${active ? 'bg-white' : 'bg-transparent'}`} data-id="element-31">
        <Icon className={`h-[22px] w-[22px] shrink-0 transition-colors ${active ? 'text-black' : 'text-zinc-500'}`} strokeWidth={active ? 2.5 : 2} data-id="element-32" />
        <AnimatePresence initial={false} data-id="element-33">
          {active && <motion.span key="label" initial={{
          opacity: 0,
          width: 0
        }} animate={{
          opacity: 1,
          width: 'auto'
        }} exit={{
          opacity: 0,
          width: 0
        }} transition={{
          duration: 0.2
        }} className="overflow-hidden whitespace-nowrap text-[13px] font-bold uppercase tracking-wide text-black" data-id="element-34">
              {label}
            </motion.span>}
        </AnimatePresence>
      </motion.div>
    </Link>;
}